import { i18n } from '../../../shared/helpers/i18n';
import { ArtifactError, ArtifactStatus } from '../../../shared/helpers/transport/cloud-api/types';
import { Artifact } from '../features/fetching/types';

export const getArtifactSubtitle = (artifact: Artifact, artifactType: 'summarization' | 'cloudRecordings') => {
    const ERRORS_MAP = {
        [ArtifactError.RECORDING_TOO_SHORT]:
            artifactType === 'summarization'
                ? i18n('conferences-history', 'summarization-too-short')
                : i18n('conferences-history', 'recording-too-short'),
        [ArtifactError.ACCESS_FORBIDDEN_CONTACT_OWNER]: i18n('conferences-history', 'access-forbidden-contact-owner'),
        [ArtifactError.ACCESS_FORBIDDEN_CONTACT_SUPPORT]: i18n(
            'conferences-history',
            'access-forbidden-contact-support'
        ),
        [ArtifactError.INSUFFICIENT_DISK_SPACE]: i18n('conferences-history', 'insufficient-disk-space'),
        [ArtifactError.OTHER]:
            artifactType === 'summarization'
                ? i18n('conferences-history', 'other-summarization')
                : i18n('conferences-history', 'other'),
    };
    const artifactFailed = artifact.status === ArtifactStatus.FAILED;
    const artifactNotReady = artifact.status === ArtifactStatus.IN_PROGRESS;
    return artifactFailed && artifact.error
        ? ERRORS_MAP[artifact.error]
        : artifactNotReady
          ? i18n('conferences-history', 'in-progress')
          : undefined;
};
